import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				background: theme.palette.common.white,
				position: "relative",
				marginBottom: 10,
				borderRadius: 6,
				zIndex: 4,
				boxShadow: "0px 3px 29px rgba(114, 136, 128, 0.15)"
			},
			btnDelete: {
				position: "absolute",
				right: -5,
				top: -5,
				cursor: "pointer",
				color: theme.palette.grey[100],
				"&&:active": {
					opacity: 0.7
				}
			},
			rootPromotion: {
				borderTop: `1px dashed ${theme.palette.grey[800]}`
			},
			wrapperPromotion: {
				marginTop: 10,
				background: theme.palette.grey[600],
				borderRadius: 4,
				padding: "5px 10px",
				fontSize: 13
			},
			headerPromotion: {
				borderBottom: `1px solid ${theme.palette.common.white}`,
				padding: "5px 0px"
			}
		}),
	{
		name: "ProductItem",
		index: 1
	}
);

export default useStyles;
